import React, { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import {useDataContext} from './CIContext'
import { FetchCiConfig } from './CredibilityIndex.api';
import Logger from '../../utils/Logger';
import { CredibilityIndexAction } from './CredibilityIndex.action';
import { PageViewType } from './CredibilityIndex.constants';
import { mpaasHttpAction } from '../../utils/MpaasHttpActionHandler';
import { toast } from 'react-toastify';
import { handlePasteNumeric, isAnyToastVisible, preventInvalidNumberInput } from './ciUtils';

const CIForm = () => {

    const context = useDataContext();
    const { state:  { clientId, isLoading }, dispatch } = context!;
    const [showLoader, setShowLoader] = useState<React.ReactNode>(<></>);

    useEffect(() => {
        return () => {
            if (isAnyToastVisible()) {
                toast.dismiss();
            }
        };
    }, [])
    
    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        
        dispatch({ type: CredibilityIndexAction.IS_LOADING, payload: { isLoading: true } });

        setShowLoader(mpaasHttpAction.loading())

        e.preventDefault();
        const payload = {
            clientId: clientId
        }

        FetchCiConfig(payload).then((response: any) => {
            if(isAnyToastVisible()) {
                toast.dismiss()
            }
            
            dispatch({
                type: CredibilityIndexAction.SET_CI_CONFIG_RESPONSE,
                payload: {
                    response: response,
                    activePage: PageViewType.TABLE_PAGE
                }
            });

            dispatch({ type: CredibilityIndexAction.IS_LOADING, payload: { isLoading: false } });
            setShowLoader(<></>)

        }).catch((error) => {
            Logger.error("Error:", error);
            dispatch({ type: CredibilityIndexAction.IS_LOADING, payload: { isLoading: false } });
            setShowLoader(<></>)
        })
    }
    const handleClientIdChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e?.target?.value;
      
        dispatch({
            type: CredibilityIndexAction.UPDATE_CLIENT_ID,
            payload: {
                clientId: value ? Number(value) : null
            }
        });
    };

    return (
        <div>
            <div className='py-3'>
                <h4 className="title">View Credibility Index Bands Configuration</h4>
                <p className="text-muted">Enter the Mpaas Client ID to view the configuration.</p>
            </div>
            <Form onSubmit={handleSubmit}>
                <div className='d-flex align-items-center'>

                    <Form.Group key="clientId" className="mb-0 mr-3">
                        <Form.Control
                            name="clientId"
                            type="number"
                            required={true}
                            autoComplete="off"
                            className={"form-control-width"}
                            placeholder='Client ID'
                            onChange={handleClientIdChange}
                            onKeyDown={preventInvalidNumberInput}
                            onPaste={handlePasteNumeric}
                        />
                    </Form.Group>
                    <Button type="submit" className="button-margin" disabled={isLoading}>Submit</Button>

                </div>

            </Form> 
            {isLoading && showLoader}
        </div>
    )
}

export default CIForm